module.exports = __webpack_public_path__ + "img/login-pattern.69ff9285.png";